"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCategoryGroupsSuccessActionWatcher = exports.createCategoryGroupListsSuccessActionWater = exports.createCategoryGroupActionWatcher = void 0;
const effects_1 = require("redux-saga/effects");
const categoryGroupsActions_1 = require("companion-app-components/flux/category-groups/categoryGroupsActions");
const core_1 = require("companion-app-components/flux/core");
const categories_1 = require("companion-app-components/flux/categories");
const auth_1 = require("companion-app-components/flux/auth");
const categoryGroupListsSelectors_1 = require("companion-app-components/flux/category-group-lists/categoryGroupListsSelectors");
const categoryGroupsSelectors_1 = require("companion-app-components/flux/category-groups/categoryGroupsSelectors");
const categoryGroupsActions = __importStar(require("data/categoryGroups/categoryGroupsActions"));
const categoryGroupListsActions_1 = require("data/categoryGroupLists/categoryGroupListsActions");
const categoryGroupsUtils_1 = require("data/categoryGroups/categoryGroupsUtils");
const mkResourceConfig = (props) => core_1.resourceStoreTypes.mkQcsSyncResourceConfig(Object.assign({ resourceName: 'categoryGroups', resourceBaseUrl: '/category-groups', getLastSyncDate: categoryGroupsSelectors_1.getLastSyncDate }, props));
function* createCategoryGroupActionWatcher() {
    const config = mkResourceConfig({
        successAction: categoryGroupsActions.createCategoryGroupsSuccessAction,
        failureAction: categoryGroupsActions.createCategoryGroupsFailureAction,
    });
    yield (0, effects_1.takeEvery)(categoryGroupsActions.createCategoryGroupsAction.type, core_1.resourceSagaUtils.qcsSyncUpdateResources, config);
}
exports.createCategoryGroupActionWatcher = createCategoryGroupActionWatcher;
function* createCategoryGroups() {
    var _a;
    const catGroups = yield (0, effects_1.select)(categoryGroupsSelectors_1.getCategoryGroupsByIdRaw);
    const isWebFirstDataset = yield (0, effects_1.select)(auth_1.authSelectors.getIsWebfirstDataset);
    if ((catGroups === null || catGroups === void 0 ? void 0 : catGroups.size) === 0 && isWebFirstDataset) {
        const categoryGroupListsFetched = yield (0, effects_1.select)(categoryGroupListsSelectors_1.getCategoryGroupLists);
        const categoryGroupListId = (_a = categoryGroupListsFetched === null || categoryGroupListsFetched === void 0 ? void 0 : categoryGroupListsFetched.first()) === null || _a === void 0 ? void 0 : _a.id;
        if (categoryGroupListId) {
            const allIncomeCategories = yield (0, effects_1.select)(categories_1.categoriesSelectors.getIncomeCOAIds);
            const allExpenseCategories = yield (0, effects_1.select)(categories_1.categoriesSelectors.getExpenseCOAIds);
            const payload = (0, categoryGroupsUtils_1.getCreateCategoryGroupsPayload)(allIncomeCategories, allExpenseCategories, categoryGroupListId);
            yield (0, effects_1.put)(categoryGroupsActions.createCategoryGroupsAction(payload));
        }
    }
}
function* createCategoryGroupListsSuccessActionWater() {
    yield (0, effects_1.takeEvery)([categoryGroupListsActions_1.createCategoryGroupListsSuccessAction, categoryGroupsActions_1.getCategoryGroupsSuccessAction], createCategoryGroups);
}
exports.createCategoryGroupListsSuccessActionWater = createCategoryGroupListsSuccessActionWater;
function* triggerGetCategoryGroups() {
    yield (0, effects_1.put)((0, categoryGroupsActions_1.getCategoryGroupsAction)());
}
function* createCategoryGroupsSuccessActionWatcher() {
    yield (0, effects_1.takeLatest)(categoryGroupsActions.createCategoryGroupsSuccessAction, triggerGetCategoryGroups);
}
exports.createCategoryGroupsSuccessActionWatcher = createCategoryGroupsSuccessActionWatcher;
exports.default = [
    createCategoryGroupActionWatcher,
    createCategoryGroupListsSuccessActionWater,
    createCategoryGroupsSuccessActionWatcher,
];
